import script from "./RoundScore.vue?vue&type=script&setup=true&lang=js"
export * from "./RoundScore.vue?vue&type=script&setup=true&lang=js"

import "./RoundScore.vue?vue&type=style&index=0&id=2c76720d&lang=css"

const __exports__ = script;

export default __exports__